import React, { Component } from "react";
import { FacebookLogin } from 'react-facebook-login-component';
import { push, vPush } from "../Services/Analytics"
import { switchURLapi } from "../Services/baseURL"
import 'whatwg-fetch'
import "./LeadPage.scss"
import dataJSON from "../../api/whoami.json"
import Helmet from "react-helmet";

const apiURLRoot = switchURLapi("http://localhost:60721/api/", "http://source-qa.a.ynet.co.il/mShort/commerce/2018/HidonNespressoAPI/api/", "https://z.ynet.co.il/mShort/commerce/2018/HidonNespressoAPI/api/");

class LeadPage extends Component {
  constructor(props) {
    super();
    this.state = {
      appState: {},
      NespressoGuy: {
        name: "NespressoGuy",
        value: 0,
        error: null,
        Proxy: 0
      },
      phone_prefix: {
        name: "phone_prefix",
        value: "050",
        error: null
      },
      whoami: 1,
      busy: false,
      isSent: true
    }
    this.responseFacebook = this.responseFacebook.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.sendHidon = this.sendHidon.bind(this);
    this.sendFBHidon = this.sendFBHidon.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.setErrorMessage = this.setErrorMessage.bind(this);
    this.addState = this.addState.bind(this);
    this.checkInput = this.checkInput.bind(this);
    this.shareBTN = this.shareBTN.bind(this);
    this.shareCustom = this.shareCustom.bind(this);
  }
  componentWillMount() {
    if (window.screen.width < 769) {
      window.scrollTo(0, 250);
    }
  }
  async componentDidMount() {
    this.setState({
      appState: await this.props.hidonState
    })

    this.addState("FullName");
    this.addState("CityAddress");
    this.addState("Email");
    this.addState("Phone");
    this.addState("NespressoGuy");
    this.addState("Describe");

    this.setState({
      whoami: (this.props.router.match.params.whoami < 1 || this.props.router.match.params.whoami > 3 ? 1 : this.props.router.match.params.whoami)
    })
    var view = 0;
    if (typeof (Storage) !== "undefined") {
      view = window.sessionStorage.getItem("viewWHOAMI");
    }
    if (!view) {
      vPush(dataJSON[(Math.round(this.props.router.match.params.whoami - 1))].name, `/whoami/${this.props.router.match.params.whoami}`);
      view = window.sessionStorage.setItem("viewWHOAMI", 1);
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      whoami: (nextProps.router.match.params.whoami < 1 || nextProps.router.match.params.whoami > 3 ? 1 : nextProps.router.match.params.whoami)
    })
    if (nextProps.router.match.params.whoami != this.state.whoami) {
      vPush(dataJSON[(Math.round(nextProps.router.match.params.whoami - 1))].name, `/whoami/${nextProps.router.match.params.whoami}`);
    }
  }
  addState(stateName) {
    this.setState({
      [stateName]: {
        name: stateName,
        value: null
      }
    })
  }
  handleInputChange(event) {
    this.setState({
      [event.target.name]: {
        name: event.target.name,
        value: event.target.value
      }
    })
    if (event.target.name == "Phone") {
      event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    }
    if (event.target.name == "FullName") {
      event.target.value = event.target.value.replace(/[0-9]/g, "").replace(/(\..*)\./g, '$1');
    }
    if (event.target.name == "NespressoGuy") {
      this.setState({
        NespressoGuy: {
          name: event.target.name,
          value: (this.state[event.target.name].value ? 0 : 1),
        }
      })
    }
  }
  shareBTN(action) {
    var shareText = "";
    var url = "";
    switch (action) {
      default:
      case "facebook":
        push("Share_Facebook", url);
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "twitter":
        push("Share_Twitter", url);
        window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        push("Share_WhatsApp", url);
        window.open("whatsapp://send?text=" + encodeURIComponent(shareText + " >> " + url), "_parent");
        break;
    }
  }
  setErrorMessage(target, msg) {
    if (this.state[target.name]) {
      this.setState({
        [target.name]: {
          name: target.name,
          value: target.value,
          error: msg
        }
      })
    }
  }
  responseFacebook(response) {
    push("Facebook_Connect", window.location.href);
    window.FB.login((r) => {
      if (r.status === 'connected') {
        this.setState({
          FacebookRespone: response
        })

        // console.log(`https://graph.facebook.com/v2.0/?ids=http://www.facebook.com/${r.authResponse.userID}&fields=id&access_token=${r.authResponse.accessToken}`)
        // fetch(`https://graph.facebook.com/v2.0/?ids=http://www.facebook.com/${r.authResponse.userID}&fields=id&access_token=${r.authResponse.accessToken}`).then(data => {
        //   console.log(data);
        // });

        this.sendFBHidon();
      } else {
        this.setState({
          FacebookRespone: false
        })
      }
    });
    // window.FB.getLoginStatus((response) => {});
  }
  hasValue(state) {
    if (state) {
      return Boolean(state.value)
    }
    return false;
  }
  returnValue(state) {
    return state.value
  }
  checkInput(state) {
    var error = "שדה חובה";
    const errors = {
      FullName: error,
      Email: error,
      Phone: error,
      CityAddress: error,
      Describe: "היינו שמחים להמשיך, אבל פיספסת שדה חובה",
    }
    if (!this.hasValue(state)) {
      if (state.name == "Describe") {
        this.props.triggerPopup({
          Title: errors[state.name]
        });
      }
      this.setErrorMessage(state, errors[state.name]);
      return false;
    }
    switch (state.name) {
      case "Email":
        if (state.value[Math.round(state.value.indexOf("@") + 1)] == state.value[Math.round(state.value.indexOf("."))]) {
          this.setErrorMessage(state, errors[state.name]);
          return false;
        }
        if (state.value[Math.round(state.value.indexOf("@") - 1)] == state.value[Math.round(state.value.indexOf("."))]) {
          this.setErrorMessage(state, errors[state.name]);
          return false;
        }
        if (state.value.indexOf("@") < 0 || state.value.indexOf(".") < 0) {
          this.setErrorMessage(state, errors[state.name]);
          return false;
        }
        break;
      case "Phone":
        if (state.value.length != 7) {
          this.setErrorMessage(state, errors[state.name]);
          return false;
        }
        break;
      case "FullName":
        if (state.value.indexOf(" ") < 0) {
          this.setErrorMessage(state, "יש להזין שם מלא");
          return false;
        }
        if (state.value.length < 2) {
          this.setErrorMessage(state, errors[state.name]);
          return false;
        }
        break;
      case "CityAddress":
        if (state.value.length < 2) {
          this.setErrorMessage(state, errors[state.name]);
          return false;
        }
        break;
      case "Describe":
        if (state.value.length < 2) {
          this.setErrorMessage(state, errors[state.name]);
          if (window.screen.width < 769) {
            window.scrollTo(0, 250);
          }
          return false;
        }
        break;
    }
    return true;
  }
  fetchData(dataLayer) {
    const state = this.state;
    const appState = this.state.appState;
    push("Form_Sent", "");

    if (!state.busy) {
      this.setState({
        busy: true,
        isSent: true
      })
      fetch(`${apiURLRoot}save`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataLayer)
      }).then(data => {
        this.setState({
          busy: false
        })
      });
    }
  }
  sendFBHidon() {
    const state = this.state;
    const appState = this.state.appState;

    if (state.FacebookRespone) {
      if (!this.checkInput(state.Describe)) {
        return;
      }
    }

    this.fetchData({
      FullName: state.FacebookRespone.name,
      Email: state.FacebookRespone.email,
      CityAddress: (state.FacebookRespone.location ? state.FacebookRespone.location.name : ""),
      Gender: (state.FacebookRespone.gender ? state.FacebookRespone.gender : ""),
      Age: (state.FacebookRespone.age_range ? state.FacebookRespone.age_range.min : ""),
      Describe: this.returnValue(state.Describe),
      FacebookID: state.FacebookRespone.id,
      Quiz: state.whoami,
      Takanon: (this.hasValue(appState.Takanon) ? this.returnValue(appState.Takanon) : "")
    })
  }
  sendHidon() {
    const state = this.state;
    const appState = this.state.appState;

    if (!this.checkInput(state.Describe)) {
      return;
    }

    if (!this.checkInput(state.FullName) ||
      !this.checkInput(state.CityAddress) ||
      !this.checkInput(state.Phone) ||
      !this.checkInput(state.Email)) {
      return;
    }

    this.fetchData({
      FullName: this.returnValue(state.FullName),
      Email: this.returnValue(state.Email),
      Phone: `${this.returnValue(state.phone_prefix)}${this.returnValue(state.Phone)}`,
      CityAddress: this.returnValue(state.CityAddress),
      Describe: this.returnValue(state.Describe),
      NespressoGuy: this.returnValue(state.NespressoGuy),
      Quiz: state.whoami,
      Takanon: (this.hasValue(appState.Takanon) ? this.returnValue(appState.Takanon) : "")
    })
  }
  shareCustom(opt) {
    var url = `https://z.ynet.co.il/mShort/commerce/2018/coffeequizz/whoami${this.state.whoami}.html`;
    switch (opt) {
      case "facebook":
        push("Share_Facebook", url);
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "twitter":
        push("Share_Twitter", url);
        window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(dataJSON[(Math.round(this.state.whoami - 1))].subteaser) + "&url=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        push("Share_WhatsApp", url);
        window.open("whatsapp://send?text=" + encodeURIComponent(dataJSON[(Math.round(this.state.whoami - 1))].subteaser + " >> " + url), "_parent");
        break;
    }
  }
  render() {
    return (
      <section className="section section-lead">
        <div className="padding">
          <div className="container">
          {/* ${(this.state.isSent ? " thanks" : "")} */}
            <div className={`whoami ${dataJSON[(Math.round(this.state.whoami - 1))].className}`}>
              <div className="whoami-padding">
                <div className="centeral" style={{ display: (this.state.isSent ? "block" : "none") }}>
                  {/* <div className="headline thanks">
                    {dataJSON[(Math.round(this.state.whoami - 1))].sum}
                  </div> */}
                  <div className="headline">
                    {dataJSON[(Math.round(this.state.whoami - 1))].name}
                  </div>
                  <div className="desc">
                    {dataJSON[(Math.round(this.state.whoami - 1))].desc}
                  </div>
                </div>
                <div style={{ display: (this.state.isSent ? "none" : "block") }}>
                  <div className="headline">
                    {dataJSON[(Math.round(this.state.whoami - 1))].name}
                  </div>
                  <div className="desc">
                    {dataJSON[(Math.round(this.state.whoami - 1))].desc}
                  </div>
                </div>
              </div>
            </div>
            <div className="shareoptions" style={{ display: (this.state.isSent ? "block" : "none") }}>
              <div className="padding-share">
                <div className="text">
                שתפו את התוצאה שהשגתם
                </div>
                <div onClick={() => this.shareCustom("twitter")} className="twitter"></div>
                <div onClick={() => this.shareCustom("whatsapp")} className="whatsapp"></div>
                <div onClick={() => this.shareCustom("facebook")} className="facebook"></div>
              </div>
            </div>
            {/* <div className="thanks-msg" style={{ display: (this.state.isSent ? "block" : "none") }}>
              <div className="padding-thanks">
                <h3>{dataJSON[(Math.round(this.state.whoami - 1))].thanks}</h3>
              </div>
            </div> */}
            <div style={{ display: (this.state.isSent ? "none" : "block") }}>
              <div className="form">
                <div className="headline">
                  {dataJSON[(Math.round(this.state.whoami - 1))].teaser}
                </div>
                <div className="desc">
                  {dataJSON[(Math.round(this.state.whoami - 1))].subteaser}
                </div>
              </div>
              <div className="freetext">
                <DomTextarea placeholder="כתבו כאן" name="Describe" id="Describe" onChange={this.handleInputChange} {...this.state} />
              </div>
              <div className="fblogin">
                <div className="headline">
                  על מנת לשלוח את תשובתכם, עליכם להתחבר:
              </div>
                <FacebookLogin socialId="203704203515607"
                  language="en_US"
                  scope="public_profile,email,user_location"
                  responseHandler={this.responseFacebook}
                  xfbml={true}
                  fields="id,email,name,location,gender,age_range"
                  version="v2.5"
                  className="facebook-login"
                  buttonText="" />
                <div className="nav">
                  <div className="line"></div>
                  <div className="circles">
                    <div className="circle">או</div>
                  </div>
                </div>
              </div>
              <div className="tofes">
                <div className="headline">
                  מלאו פרטים
              </div>
                <div className="rows">
                  <DomField type="text" placeholder="שם מלא" name="FullName" id="FullName" onChange={this.handleInputChange} {...this.state} />
                  <DomField type="text" placeholder="כתובת" name="CityAddress" id="CityAddress" onChange={this.handleInputChange} {...this.state} />
                  <DomField type="tel" placeholder="טלפון" name="Phone" id="Phone" onChange={this.handleInputChange} {...this.state} />
                  <DomField type="email" placeholder="דוא&quot;ל" name="Email" id="Email" onChange={this.handleInputChange} {...this.state} />
                  <DomCheckboxField type="checkbox" name="NespressoGuy" id="NespressoGuy" onChange={this.handleInputChange} {...this.state} />
                </div>
                <div className="button" onClick={this.sendHidon}>
                  <div className="button-text">
                    שלחו
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}


const ErrorMsg = (props) => {
  if (props[props.target]) {
    return (
      <div className="error-msg" style={{ display: (props[props.target] ? "block" : "none") }}>{props[props.target].error}</div>
    )
  } else {
    return (
      <div></div>
    )
  }
}
const DomField = (props) => {
  switch (props.type) {
    case "tel":
      return (
        <div className="field tel">
          <ErrorMsg target={props.name}  {...props} />
          <input type={props.type} placeholder={props.placeholder} name={props.name} id={props.id} onChange={props.onChange} />
          <select name="phone_prefix" id="phone_prefix" placeholder="050" onChange={props.onChange}>
            <option value="">05..</option>
            <option value="050">050</option>
            <option value="051">051</option>
            <option value="052">052</option>
            <option value="053">053</option>
            <option value="054">054</option>
            <option value="055">055</option>
            <option value="056">056</option>
            <option value="058">058</option>
            <option value="059">059</option>
            <option value="072">072</option>
            <option value="073">073</option>
            <option value="074">074</option>
            <option value="077">077</option>
            <option value="078">078</option>
            <option value="079">079</option>
            <option value="08">08</option>
            <option value="09">09</option>
            <option value="04">04</option>
            <option value="03">03</option>
            <option value="02">02</option>
          </select>
        </div>
      )
      break;
    default:
      return (
        <div className="field">
          <ErrorMsg target={props.name}  {...props} />
          <input type={props.type} placeholder={props.placeholder} name={props.name} id={props.id} onChange={props.onChange} />
        </div>
      )
  }
}
const DomTextarea = (props) => {
  return (
    <div className="field">
      <ErrorMsg target={props.name}  {...props} />
      <textarea placeholder={props.placeholder} name={props.name} id={props.id} onChange={props.onChange}></textarea>
    </div>
  )
}
const DomCheckboxField = (props) => {
  return (
    <div className="field checkbox">
      <ErrorMsg target={props.name}  {...props} />
      <input type={props.type} placeholder={props.placeholder} name={props.name} id={props.id} value={1} onChange={props.onChange} />
      <label htmlFor={props.id}>אני חבר/ה במועדון נספרסו</label>
      <div style={{ display: (props[props.name].value == 1 ? "block" : "none") }} className="notes">* אנא וודאו כי מספר הטלפון שמילאתם מעלה הוא המספר שאיתו אתם מזדהים במועדון נספרסו</div>
    </div >
  )
}
export default LeadPage;



// WEBPACK FOOTER //
// ./src/Components/LeadPage/LeadPage.js